import EMVERSITY from "@/assets/industry-co-led/partners/NEPHROPLUS.png";
import Icon1 from "@/assets/industry-co-led/logo/madel.png";
import Icon2 from "@/assets/industry-co-led/logo/network.png";

import Student1 from "@/assets/students/student1.png";
import Student2 from "@/assets/students/student2.png";
import Student3 from "@/assets/students/student3.png";
import Student4 from "@/assets/students/student4.png";

const OJLImg1 ="https://cdn.msu.edu.in/medium_msu_emergency_medical_tech1_f3261b53d1.webp";
const OJLImg2 = "https://cdn.msu.edu.in/medium_msu_emergency_medical_tech3_596a3c4319.webp";
const OJLImg3 = "https://cdn.msu.edu.in/medium_msu_emergency_medical_tech4_509a1d5471.webp";
const OJLImg4 = "https://cdn.msu.edu.in/medium_msu_emergency_medical_tech2_d2775e1654.webp";
const OJLImg5 = "https://cdn.msu.edu.in/medium_msu_emergency_medical_tech6_b923c3ee90.webp";
const OJLImg6 = "https://cdn.msu.edu.in/medium_msu_emergency_medical_tech5_16b83ba5e8.webp";

const Img1 = "https://cdn.msu.edu.in/Radiology_1_fd63892112.webp"; 
const Img2 = "https://cdn.msu.edu.in/dialysis_3_802e00fc5b.jpg";                                  
const Img3 = "https://cdn.msu.edu.in/R_4_20cfa25db5.webp";                                       
const Img4 = "https://cdn.msu.edu.in/R_3_bb8d3983be.webp";                     
const Img5 = "https://img.youtube.com/vi/lTWke3-IGz4/hqdefault.jpg";                              


export const bachelorDTT = {

    heroSection: {
        breadcrumb: [
            { name: "Home", url: "/" },
            { name: "Industry Co-led UG Programmes", url: "/industry-co-led-ug-programmes" },
            { name: "Bachelor of Dialysis Therapy Technology", url: "" }
        ],
        bannerImg: '/assets/industry-co-led-banner.png',
        title: "Bachelor of Dialysis Therapy Technology",
        poweredBy: {
            text: "Industry Skilling Partner",
            logo: EMVERSITY
        },
        duration: "4 Year Undergraduate Programme",
        description:
            "Learn about Human Anatomy and Physiology, General Biochemistry, Biomedical Waste Management and more.",

        stats: [
            {
                value: "Up to 70%",
                label: "Practical Curriculum"
            },
            {
                value: "Paid",
                label: "On-the-job learning"
            },
            {
                value: "100%",
                label: "Placement Assistance"
            }
        ],

        buttons: {
            enroll: "Enroll Now"
        },

        video: {
            thumbnail: 'https://img.youtube.com/vi/wMCs06gZzyA/hqdefault.jpg',
            buttonText: "Watch Programme Video",
            url: "https://www.youtube.com/embed/wMCs06gZzyA"
        }
    },

    aboutSection: {
        tag: "ABOUT THE PROGRAMME",

        title: "Undergraduate Healthcare Programme in Dialysis Technology",

        description: [
            "The Bachelor of Dialysis Therapy Technology is designed to provide students with comprehensive knowledge of renal nutrition, physiology and modern dialysis procedures. The programme equips learners with the technical and clinical skills required to assist in, monitor and manage various extracorporeal therapies, including advanced cardiac life support, medical electronics, renal transplant support and critical care renal replacement procedures.",

            "Structured with a blend of academic learning and practical exposure, the programme prepares students for real-world healthcare environments through hands-on dialysis technician training and patient-care practices. Suitable for students seeking a career in allied and paramedical healthcare after higher secondary education, the programme opens opportunities across hospitals, dialysis units, ICUs and specialised renal care centres."
        ],

        stats: [
            {
                value: "Up to 70%",
                label: "Practical Curriculum"
            },
            {
                value: "Paid",
                label: "On-the-job learning"
            },
            {
                value: "100%",
                label: "Placement Assistance"
            }
        ],

        approvals: [
            "UGC Approved",
            "NEP 2020 Aligned",
            "Govt. Scholarships Available"
        ],

        journeyTitle: "Your 4 Year Journey",

        journey: [
            {
                phase: "YEAR 1",
                title: "Foundations in Medical & Dialysis Sciences",
                description: "Understand Human Anatomy, Physiology, Biochemistry, Medical Terminology, Basics of Dialysis Therapy through theory, practicals, clinical exposure and more"
            },
            {
                phase: "YEAR 2",
                title: "Clinical Sciences & Dialysis Technology",
                description: "Learn Pathology, Microbiology, Pharmacology, Kidney Disease Management, Dialysis Instrumentation, Nursing Care and Medical Electronics with hands-on clinical training"
            },
            {
                phase: "YEAR 3",
                title: "Advanced Dialysis & Renal Care",
                description: "Develop expertise in Dialysis Therapies, Renal Nutrition, Renal Transplantation, Advanced Extracorporeal Therapies, Quality Assurance and Cardiac Life Support"
            },
            {
                phase: "FINAL PHASE",
                title: "Internship, Research & Clinical Practice",
                description: "Gain real-world experience through rotatory internships, advanced clinical postings and a research dissertation in dialysis and renal care"
            },
            {
                phase: "GRADUATE",
                title: "Bachelor of Dialysis Therapy Technology",
                description: "Industry-ready allied healthcare professional"
            }
        ]
    },

    offeringSection: {
        tag: "OUR OFFERING",

        title: {
            first: "Comprehensive",
            highlight: "Allied Healthcare Education"
        },

        description:
            "We offer a UGC-approved, 4-year full-time undergraduate degree of Bachelor of Dialysis Therapy Technology at Medhavi Skills University, Sikkim. It is an industry-aligned healthcare degree designed to build strong paramedical skills and prepare students for diverse roles.",

        learningBox: {
            title: "Key Areas of Learning",

            points: [
                "Human Anatomy",
                "General Pharmacology",
                "Biomedical Waste Management",
                "Medical Electronics for Health Sciences",
                "Renal Transplantation and Coordination",
                "Basic and Advanced Cardiac Life Support"
            ]
        },

        image: 'https://cdn.msu.edu.in/R_5_21755354c6.webp'
    },

    whyEMT: {
        tag: "WHY DIALYSIS THERAPY TECHNOLOGY. WHY NOW.",
        title: "Addressing the Need for Advanced Renal Care Professionals",
        description:
            "The Undergraduate Programme in Dialysis Technology equips learners with specialised clinical expertise, practical dialysis training and patient-care competencies required to support modern renal healthcare services across hospitals, dialysis centres and critical care units.",

        stats: [
            {
                value: "13.4%",
                text: "of the global population is affected by CKD, driving sustained demand for life-saving dialysis as per PubMed Central",
            },
            {
                value: "220,000 ESRD",
                text: "cases are added annually in India, creating demand for 34 million dialysis sessions, according to Express Healthcare",
            },
            {
                value: "US$ 638 billion",
                text: "is the projected value of India's healthcare sector by 2025, according to India Brand Equity Foundation",
            },
        ],
    },

    msuAdvantages: {
        tag: "MSU ADVANTAGES",
        title: "Programme by NephroPlus, Delivered at MSU Campus",
        description:
            "Your edge at Medhavi Skills University, where real-world learning, industry exposure and future-ready skills come together.",

        cards: [
            {
                number: "01",
                text: "Only university in Sikkim aligned with paid On-the-Job Learning embedded curriculum for practical learning",
            },
            {
                number: "02",
                text: "Only university in Sikkim to ensure 100% of our student applicants receive government scholarships",
            },
            {
                number: "03",
                text: "Well-equipped healthcare labs, advanced training setups and hands-on field training",
            },
        ],

        pointerTitle: "Highlights from The Programme:",

        highlights: [
            "Programme aligned with NEP 2020, focused on Learning Outcome Based Education",
            "Up to 70% practical based curriculum",
            "Paid On-the-Job Learning (OJL)",
            "Industry-aligned curriculum & hands-on learning",
            "Learn from seasoned healthcare professionals",
            "Immersive industry exposure through industry visits, guest lectures and networking opportunities",
            "Opportunity to 'learn and earn' through immersive on-the-job learning, industry projects and internships with leading companies",
            "Engage with industry experts to get invaluable insights and real-world perspectives",
            "Programme is NCAHP aligned"
        ],

        image: 'https://cdn.msu.edu.in/advantages_e4b02487af.webp',
    },

    CTA: {
        title: "Start Your Journey in Renal Care with Nephroplus's",
        highlights: "Bachelor of Dialysis Therapy Technology",
        url: "#",
        btnName: "Apply Now"
    },

    onJobTrainingData: {
        tag: "Hands-On Experience",
        title: "On-the-Job Learning",
        description: "At Medhavi Skills University, On-the-Job Learning (OJL) enables students to gain real industry experience and earn a stipend while they learn.",
        images: [
            { id: 1, src: OJLImg1, alt: "Medical training" },
            { id: 2, src: OJLImg2, alt: "Lab practice" },
            { id: 3, src: OJLImg3, alt: "Patient training" },
            { id: 4, src: OJLImg4, alt: "Lab testing" },
            { id: 5, src: OJLImg5, alt: "Computer lab work" },
            { id: 6, src: OJLImg6, alt: "Chemical lab testing" }
        ]
    },

    addtionSkill: {
        courseSections: {
            AdditionalSkills: {
                tag: "Bonus Credentials",
                title: "Additional Skills Certifications",
                description: "At Medhavi Skills University, students have the opportunity to gain credible Skill Certifications like Basic Life Support (BLS), Basic Trauma Life Support (BTLS) and more. These certifications, earned alongside the degree, enhance credibility, strengthen industry relevance and prepare students for employment with nationally and globally recognised credentials.",
                image: {
                    url: 'https://cdn.msu.edu.in/small_RAH_6083_9150e01c9b.jpg',
                    alternativeText: "Skill Certification"
                },
                items: [
                    {
                        id: 1,
                        text: "BLS, BTLS Certified",
                        icon: Icon1
                    },
                    {
                        id: 2,
                        text: "Nationally & Globally Recognised",
                        icon: Icon2
                    }
                ],
                button: {
                    text: "Apply Now",
                    link: "/apply"
                }
            }
        }
    },

    DoExperienceLearndata: {
        tag: "INFRASTRUCTURE",
        title: "Do-Experience-Learn",
        description:
            "Discover the advantage of MSU's cutting-edge infrastructure, featuring modern laboratories, classrooms, and industry-relevant facilities",

        images: [
            { id: 1, src: Img1, size: "large", alt: "Do-Experience-Learn-lab" },
            { id: 2, src: Img2, size: "large", alt: "Do-Experience-Learn-lab" },
            { id: 3, src: Img3, size: "small", alt: "Do-Experience-Learn-lab" },
            { id: 4, src: Img4, size: "small", alt: "Do-Experience-Learn-lab" },
            { id: 5, src: Img5, size: "small", alt: "Do-Experience-Learn-lab" },
        ],
    },

    studentStoriesData: {
        title: "Medhavians Speak",
        subText: "These stories reflect what happens when learning goes beyond theory. From hands-on training to real-world exposure, our students build skills that translate directly into careers.",
        students: [
            { name: "Radhika Chettri", image: Student2, videLink: "https://cdn.msu.edu.in/Student-Testimonials/Allied-Healthcare-Long.mp4", shortUrl: "https://cdn.msu.edu.in/Student-Testimonials/Allied-Healthcare-short.mp4" },
            { name: "Pratik Chettri", image: Student3, videLink: "https://cdn.msu.edu.in/Student-Testimonials/Computer-Science-Long.mp4", shortUrl: "https://cdn.msu.edu.in/Student-Testimonials/Computer-Science+-short.mp4" },
            { name: "Suhana Sharma", image: Student4, videLink: "https://cdn.msu.edu.in/Student-Testimonials/Pharmacy-Long.mp4", shortUrl: "https://cdn.msu.edu.in/Student-Testimonials/Pharmacy-short.mp4" },
            { name: "Hissey Bhutia", image: Student1, videLink: "https://cdn.msu.edu.in/Student-Testimonials/Nursing-Long.mp4", shortUrl: "https://cdn.msu.edu.in/Student-Testimonials/Nursing-short.mp4" },
        ],
    },

    eligibility: {
        tag: "ELIGIBILITY",
        title: "Eligibility",
        description: "10+2 (Science) with 50% Aggregate",
        button: {
            text: "Apply Now",
            url: ""
        },
    },

    careerProspects: {
        tag: "CAREER PROSPECTS",
        heading: "Career Prospects",
        description: "Join this healthcare course and embark on a rewarding journey in the heart of the healthcare industry",
        roles: [
            "Dialysis Technologist/Hemodialysis Specialist",
            "Renal Care Officer/Kidney Care Coordinator",
            "Dialysis Unit Supervisor/Clinical Operations Assistant",
            "Clinical Dialysis Technician/Patient Care Technologist",
            "Renal Laboratory Technologist/Clinical Support Staff",
            "Critical Care Dialysis Technologist",
            "Peritoneal Dialysis Technologist",
            "Dialysis Equipment Technologist/Biomedical Support Assistant",
            "Renal Diet & Nutrition Support Coordinator",
            "Dialysis Patient Education Facilitator",
            "Healthcare Consultant – Renal Care & Dialysis Services",
            "Hospital Renal Department Executive",
            "Research Associate – Nephrology/Dialysis Studies",
            "Entrepreneur (Dialysis Units/Renal Care Services)"
        ]
    },

    curriculumStructure: {
        label: "What You Will Learn",
        heading: "Curriculum Structure",
        description: "Step into a future-focused learning environment with industry-oriented programmes designed to build practical skills, real-world readiness and broad career opportunities across disciplines.",
        semesters: [
            {
                name: "Semester 1",
                title: "Building Medical & Renal Foundations",
                description: "This semester introduces students to the fundamentals of human anatomy, physiology, biochemistry, and medical terminology while building awareness of renal sciences and dialysis therapy through foundational academic and practical learning experiences.",
                subjects: [
                    { name: "Medical Terminology and Record Keeping (including anatomical terms)", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
                    { name: "Professionalism and Values & Indian Constitution", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
                    { name: "Human Anatomy", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
                    { name: "Human Physiology", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
                    { name: "Biochemistry", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
                    { name: "Introduction to Dialysis Therapy", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
                    { name: "Human Anatomy (Practicals)", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
                    { name: "Human Physiology (Practicals)", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
                    { name: "Biochemistry (Practicals)", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
                    { name: "Community Orientation and Clinical Visit (CT)", bgColor: "bg-[#E8D4FF]", textColor: "text-[#7B2CBF]" }
                ]
            },
            {
                name: "Semester 2",
                title: "Understanding Diseases & Patient Care Practices",
                description: "Students develop knowledge in pathology, microbiology, pharmacology, and renal disease concepts while gaining exposure to patient care techniques, dialysis fundamentals, and essential clinical practices.",
                subjects: [
                    { name: "Pathology", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
                    { name: "Microbiology", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
                    { name: "General Pharmacology", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
                    { name: "Applied Anatomy & Physiology related to Dialysis Therapy", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
                    { name: "Fundamentals of Dialysis Therapy", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
                    { name: "Pathology (Practicals)", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
                    { name: "Microbiology (Practicals)", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
                    { name: "Applied Anatomy & Physiology related to Dialysis Therapy (Practicals)", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
                    { name: "Fundamentals of Dialysis Therapy (Practicals)", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
                    { name: "Clinical Postings I (CT)", bgColor: "bg-[#E8D4FF]", textColor: "text-[#7B2CBF]" }
                ]
            },
            {
                name: "Semester 3",
                title: "Developing Clinical & Technical Dialysis Skills",
                description: "This semester focuses on kidney disease management, dialysis instrumentation, healthcare ethics, infection control, and patient monitoring, supported by practical training in clinical dialysis procedures.",
                subjects: [
                    { name: "Sociology in Health Care", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
                    { name: "Biomedical Waste Management", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
                    { name: "Pathophysiology of the Kidney Diseases", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
                    { name: "Elective Course-I", bgColor: "bg-[#FFD4E5]", textColor: "text-[#C41E3A]" },
                    { name: "Instrumentation Specific to Dialysis Therapy", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
                    { name: "Basic Principles of Nursing Care", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
                    { name: "Medical Law and Ethics", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
                    { name: "Instrumentation Specific to Dialysis Therapy (Practicals)", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
                    { name: "Clinical Postings II (CT)", bgColor: "bg-[#E8D4FF]", textColor: "text-[#7B2CBF]" }
                ]
            },
            {
                name: "Semester 4",
                title: "Advancing Dialysis Procedures & Applied Learning",
                description: "Students gain a deeper understanding of dialysis therapies, renal nutrition, medical electronics, and research methodology while strengthening their hands-on expertise through applied clinical training.",
                subjects: [
                    { name: "Pharmacology related to Dialysis Therapy", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
                    { name: "Psychology", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
                    { name: "Renal Nutrition", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
                    { name: "Dialysis Therapies – Part I", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
                    { name: "Medical Electronics for Health Sciences", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
                    { name: "Research Methodology and Biostatistics", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
                    { name: "Pharmacology related to Dialysis Therapy (Practicals)", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
                    { name: "Dialysis Therapies – Part I (Practicals)", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
                    { name: "Clinical Postings III (CT)", bgColor: "bg-[#E8D4FF]", textColor: "text-[#7B2CBF]" }
                ]
            },
            {
                name: "Semester 5",
                title: "Specialising in Renal Therapies & Transplant Support",
                description: "This semester emphasises advanced extracorporeal therapies, renal transplantation, evidence-based dialysis practices, and specialised patient-care techniques required in modern renal healthcare environments.",
                subjects: [
                    { name: "Dialysis Therapies – Part II", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
                    { name: "Renal Transplantation and Coordination", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
                    { name: "Clinical Problems and Evidenced Based Practice in Dialysis Therapy", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
                    { name: "Advanced Extracorporeal Therapies", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
                    { name: "Elective Course-II", bgColor: "bg-[#FFD4E5]", textColor: "text-[#C41E3A]" },
                    { name: "Renal Transplantation and Coordination (Practicals)", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
                    { name: "Advanced Extracorporeal Therapies (Practicals)", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
                    { name: "Dialysis Therapies – Part II (Practicals)", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
                    { name: "Clinical Postings IV (CT)", bgColor: "bg-[#E8D4FF]", textColor: "text-[#7B2CBF]" }
                ]
            },
            {
                name: "Semester 6",
                title: "Enhancing Critical Care & Professional Competencies",
                description: "Students explore recent advancements in renal replacement therapies, quality assurance, cardiac life support, healthcare management, and patient safety practices alongside intensive clinical exposure.",
                subjects: [
                    { name: "Recent Advancements in Renal Replacement Therapies", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
                    { name: "Principals of Management", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
                    { name: "Introduction to Quality Assurance in Dialysis and Patient Safety", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
                    { name: "Basic and Advanced Cardiac Life Support", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
                    { name: "Elective Course-III", bgColor: "bg-[#FFD4E5]", textColor: "text-[#C41E3A]" },
                    { name: "Recent Advancements in Renal Replacement Therapies (Practicals)", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
                    { name: "Basic and Advanced Cardiac Life Support (Practicals)", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
                    { name: "Clinical Postings V (CT)", bgColor: "bg-[#E8D4FF]", textColor: "text-[#7B2CBF]" }
                ]
            },
            {
                name: "Semester 7",
                title: "Clinical Internship & Real-World Hospital Exposure",
                description: "This phase provides immersive hospital-based learning through supervised clinical rotations across dialysis units, ICUs, renal care departments, and transplant support settings.",
                subjects: [
                    { name: "Compulsory Rotatory Internship", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" }
                ]
            },
            {
                name: "Semester 8",
                title: "Industry Readiness & Professional Skill Development",
                description: "The final semester focuses on advanced clinical practice, project work, interdisciplinary collaboration, communication skills, and professional readiness for careers in dialysis and allied healthcare.",
                subjects: [
                    { name: "Compulsory Rotatory Internship", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
                    { name: "Dissertation/Project", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" }
                ]
            }
        ]
    },

    faq: {
        id: 102,
        title: "Find quick answers to the most common questions about our programme",
        FAQ: [
            {
                id: 1,
                Question: "What is the university's role and what is Nephroplus's role?",
                Answer: "MSU manages all academic matters — admissions, examinations, marksheets, transcripts, and degree conferral. All fees are payable directly to the university. Nephroplus is the industry-skilling partner and delivers training, industry-co-designed skill modules, clinical internship facilitation and placement assistance. Nephroplus does not collect fees, conduct exams or award degrees."
            },
            {
                id: 2,
                Question: "Is placement or internship stipend guaranteed?",
                Answer: "We provide 100% placement support through our network of 500+ healthcare employer partners and guarantee structured clinical internships as part of the programme. While placements are not guaranteed, students receive extensive career assistance and industry exposure. Internship stipend amounts may vary depending on the employer, and final hiring and stipend decisions rest with the host institution."
            },
            {
                id: 3,
                Question: "Is this program recognised, and is it full-time?",
                Answer: "Yes, this is a full-time, on-campus program. MSU is established under the Medhavi Skills University, Sikkim Act, 2021 and is recognised by the UGC under Section 2(f). The curriculum is aligned with the NCAHP Act 2021 framework. Students should verify current NCAHP notifications and state council registration requirements directly with the university."
            },
            {
                id: 4,
                Question: "How do I apply?",
                Answer: "Applications are submitted through MSU’s official admissions portal. Candidates may be required to appear for the Medhavi Scholarship & Aptitude Test (MSAT). For eligibility verification, fee details, and application deadlines, please contact the MSU admissions office directly."
            },
            {
                id: 5,
                Question: "What is the Head Start Programme?",
                Answer: "The Head Start Programme is a zero-cost, online bridge course offered before classes begin. It covers foundational concepts and essential skills for your chosen field. Participation is voluntary, non-credit-bearing, and does not affect admission status or academic standing. Students who successfully complete it receive a complimentary laptop and may be eligible for additional scholarships."
            },
            {
                id: 6,
                Question: "Is this programme NCAHP aligned?",
                Answer: "Yes. The curriculum is subject to periodic revision by MSU in alignment with NCAHP guidelines and evolving industry requirements. Students should refer to the university’s official academic notifications for the latest syllabus."
            },
        ]
    },

    coursePrice: { price: "₹4,80,000" }

};